import { Link } from "react-router-dom";
import { UtensilsCrossed, Trophy, Wine, ChevronRight } from "lucide-react";
import { useGuestLang, LangToggle } from "@/lib/guestI18n";

const OPTIONS = [
  { to: "/vote", title: "Vote for Your Favorites", sub: "Best table, costume and food. Scan your ticket to vote.", Icon: Trophy, tone: "from-rose-500 to-orange-500", tid: "portal-vote-btn" },
  { to: "/recharge", title: "Recharge Your Drinks", sub: "Scan your ticket barcode and pay by card.", Icon: Wine, tone: "from-orange-500 to-amber-500", tid: "portal-recharge-btn" },
];

export default function EventPortal() {
  const { lang, setLang, t } = useGuestLang();
  return (
    <div className="min-h-screen bg-[#0B1120] text-slate-100 relative overflow-hidden" data-testid="event-portal-page">
      <LangToggle lang={lang} setLang={setLang} />
      <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-orange-500/20 blur-3xl" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-rose-600/20 blur-3xl" />
      <div className="relative z-10 max-w-md mx-auto px-4 py-12 space-y-8">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-500 to-rose-500 flex items-center justify-center shadow-2xl shadow-orange-500/30 mb-4"><UtensilsCrossed className="text-white" size={30} /></div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">FOOD BAZAAR</h1>
          <h2 className="font-display text-base md:text-lg font-bold text-orange-400 tracking-tight" data-testid="portal-subtitle">{t("WELCOME! WHAT WOULD YOU LIKE TO DO?")}</h2>
        </div>
        <div className="space-y-4">
          {OPTIONS.map(({ to, title, sub, Icon, tone, tid }, i) => (
            <Link key={to} to={to} data-testid={tid}
              className="group flex items-center gap-4 rounded-2xl bg-[#131D33] border border-slate-800 hover:border-orange-500/60 p-5 transition-[border-color,transform] duration-200 active:scale-[0.98] animate-in fade-in slide-in-from-bottom-2"
              style={{ animationDelay: `${i * 90}ms` }}>
              <div className={`w-14 h-14 shrink-0 rounded-xl bg-gradient-to-br ${tone} flex items-center justify-center`}><Icon className="text-white" size={26} /></div>
              <div className="flex-1">
                <div className="font-display text-xl font-black tracking-tight text-white">{t(title)}</div>
                <div className="text-sm text-slate-400">{t(sub)}</div>
              </div>
              <ChevronRight className="text-slate-500 group-hover:text-orange-400 transition-colors" />
            </Link>
          ))}
        </div>
        <p className="text-center text-xs text-slate-500">{t("Need help or paying cash? Visit the Registration desk.")}</p>
      </div>
    </div>
  );
}
